import { API_BASE_URL, itemsOnPage } from "../assets/const";
import { createNotification } from "../components/Notifications/Notifications";
import { checkAndUpdateToken } from "./auth";
import { buildDefaultHeaders } from "./helper";
import { SET_CURRENT_TERM, SET_TERMS_COUNT, SET_TERMS_LIST, SET_TERMS_LOADING, SET_TERMS_PAGE } from "./types";


export const setPage = (pageNumber) => ({ type: SET_TERMS_PAGE, payload: pageNumber })

export const getTermsList = (year) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    try {
      dispatch({ type: SET_TERMS_LOADING, payload: true });
      const { pageNumber } = getState().terms
      const limit = itemsOnPage
      const offset = itemsOnPage * pageNumber
      const urlParams = new URLSearchParams({ limit, offset }).toString();
      const yearParam = year ? `?schoolyear=${encodeURIComponent(year)}` : '';
      const response = await fetch(`${API_BASE_URL}/terms${yearParam}`, {
        // ?${urlParams}
        method: "GET",
        ...buildDefaultHeaders(getState),
      });
      if (response.ok) {

        const { cnt: count, terms } = await response.json();
        const pageCount = Math.ceil(count / itemsOnPage)

        dispatch({ type: SET_TERMS_LIST, payload: terms });
        dispatch({ type: SET_TERMS_COUNT, payload: { pageCount, count } });

      } else {
        dispatch({ type: SET_TERMS_LIST, payload: [] });
        // dispatch(getTermsList())
        createNotification('error', 'Информация не найдена');
      }
    } catch (ERR) {

    }
  }
  dispatch({ type: SET_TERMS_LOADING, payload: false });
};

export const getCurrentTerm = (termId) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  dispatch({ type: SET_CURRENT_TERM, payload: {} });
  if (getState().auth.token) {
    dispatch({ type: SET_TERMS_LOADING, payload: true });
    const response = await fetch(`${API_BASE_URL}/terms/${termId}`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const payload = await response.json();
      dispatch({ type: SET_CURRENT_TERM, payload });
    }
  }
  dispatch({ type: SET_TERMS_LOADING, payload: false });
};

export const deleteTerm = (data, year) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  let nextYear = year
  if (getState().auth.token) {
    dispatch({ type: SET_TERMS_LOADING, payload: true });
    const response = await fetch(`${API_BASE_URL}/terms/${data.trmid}`, {
      method: "DELETE",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const { list, pageNumber } = getState().terms
      // list.length < 2 значит удаляемый период был последним для выбранного года - запрашиваем без фильтра по году
      const isLastForYear = list.length < 2
      isLastForYear && dispatch(setPage(pageNumber - 1))
      nextYear = isLastForYear ? '' : year
      await dispatch(getTermsList(nextYear));
    }
  }
  dispatch({ type: SET_TERMS_LOADING, payload: false });
  return nextYear;
};

export const updateTerm = (termId, data) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_TERMS_LOADING, payload: true });
    try {
      const response = await fetch(`${API_BASE_URL}/terms/${termId}`, {
        method: "PUT",
        body: JSON.stringify(data),
        ...buildDefaultHeaders(getState),
      });

      if (response.ok) {
        await dispatch(getTermsList(data.year));
        createNotification('success', 'Успешно обновлен период');
        dispatch({ type: SET_TERMS_LOADING, payload: false });
        return true;
      } else {
        const result = await response.json();
        createNotification('error', result.error?.[0]?.msg || result?.[0]?.msg || 'Ошибка при обновлении');
      }
    } catch (ERR) {
      console.log(ERR);
      createNotification('error', 'Не удалось обновить период');
    }
  }
  dispatch({ type: SET_TERMS_LOADING, payload: false });
  return false;
};

export const createTerm = (data) => async (dispatch, getState) => {
  console.log('data::: ', data);
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_TERMS_LOADING, payload: true });
    try {
      const response = await fetch(`${API_BASE_URL}/terms`, {
        method: "POST",
        body: JSON.stringify(data),
        ...buildDefaultHeaders(getState),
      });

      if (response.ok) {
        await dispatch(getTermsList(data.year));
        createNotification('success', 'Успешно создан период');
        dispatch({ type: SET_TERMS_LOADING, payload: false });
        return true;
      } else {
        const result = await response.json();
        createNotification('error', result.error?.[0]?.msg || result?.[0]?.msg || 'Ошибка при создании');
      }
    } catch (ERR) {
      console.log(ERR);
      createNotification('error', 'Не удалось создать период');
    }
  }
  dispatch({ type: SET_TERMS_LOADING, payload: false });
  return false;
};
